import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

import { ToastrService } from 'ngx-toastr';
import AppConfigService from '../app-config.service';

@Injectable({ providedIn: 'root' })
export default class AuthServerProvider {
  constructor(
    private http: HttpClient,
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private toastr: ToastrService
  ) {}

  getToken() {
    return this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
  }

  login(credentials): Observable<any> {
    const data = {
      username: credentials.username,
      password: credentials.password,
      rememberMe: credentials.rememberMe
    };

    function authenticateSuccess(resp) {
      const oauthToken = resp.body.tokenDetails.access_token;
      this.storeAuthenticationToken(oauthToken, credentials.rememberMe);
      if (resp.body.notification_feeds) {
        this.showFeedNotification(resp.body.notification_feeds);
      }
      return oauthToken;
    }

    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/authenticate`, data, { withCredentials: false, observe: 'response' }).pipe(map(authenticateSuccess.bind(this)));
  }

  loginWithToken(jwt, rememberMe) {
    if (jwt) {
      this.storeAuthenticationToken(jwt, rememberMe);
      return Promise.resolve(jwt);
    }
    return Promise.reject(new Error('auth-jwt-service Promise reject'));
  }

  storeAuthenticationToken(jwt, rememberMe) {
    if (rememberMe) {
      this.$localStorage.store('authenticationToken', jwt);
    } else {
      this.$sessionStorage.store('authenticationToken', jwt);
    }
  }

  logout(): Observable<any> {
    return new Observable((observer) => {
      this.$localStorage.clear('authenticationToken');
      this.$sessionStorage.clear('authenticationToken');
      observer.complete();
    });
  }

  showFeedNotification(feeds) {
    try {
      feeds.forEach((element) => {
        const toast = this.toastr.success(element.message.replace('</br>', ' \n '));
        toast.onTap.subscribe(() => {
          this.closeMessage(element.id);
        });
      });
    } catch (error) {
    }
  }

  closeMessage(messageId) {
    const payload = {
      id: messageId,
      notificationRead: true
    };
    this.http.put(`${AppConfigService.envConfig.fssServicesBaseUrl}api/adminqueue/notificationread`, payload).subscribe(() => {
    });
  }

  refreshAccessToken() {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/refreshtoken`, null, { responseType: 'text' });
  }

  logoutBackend() {
    this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/authenticate/logout`, null, { withCredentials: true }).subscribe();
  }
}
